/* Booster Case — personalizador 3D · Pokeremmicias */
(() => {
  const root = document.querySelector('[data-pkrm-bc]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-pkrm-bc-config]').textContent);
  const mv = root.querySelector('model-viewer');
  const form = root.querySelector('form');
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => [...el.querySelectorAll(s)];
  const T = cfg.i18n || {};
  const EN = cfg.lang === 'en';
  const cname = (c) => (EN && c.en ? c.en : c.name);
  const fmt = (s, o) => s.replace(/\{(\w+)\}/g, (m, k) => (k in o ? o[k] : m));

  // Texture canvases keep the printed proportions of each zone (mm)
  const ZONES = {
    Trasera:   { w: 1024, h: 1621, fit: 'cover',   side: 'back',  min: 1200, ideal: '1900 × 3000' },  // 96 x 152 mm
    Cabezal:   { w: 1600, h: 304,  fit: 'contain', side: 'front', min: 500,  ideal: '1600 × 300' },   // 78 x 15 mm band under the coin
    MonedaImg: { w: 768,  h: 768,  fit: 'cover',   side: 'coin',  min: 300,  ideal: '800 × 800' }     // 27 mm disc
  };
  const PARTS = { Cuerpo: 'Carcasa', AlmSup: 'Almohadillas de arriba', AlmInf: 'Almohadillas de abajo', Moneda: 'Moneda' };

  const state = {
    line: 'PLA Basic',
    part: 'Cuerpo',
    colors: {},
    uploads: {},
    fit: { Trasera: { zoom: 100, x: 0, y: 0 }, Cabezal: { zoom: 100, x: 0, y: 0 }, MonedaImg: { zoom: 100, x: 0, y: 0 } },
    ready: false
  };

  /* ---------- helpers ---------- */
  const err = $('[data-error]');
  const showError = (msg) => { err.textContent = msg; err.hidden = !msg; if (msg) err.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); };
  const nextFrame = () => new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
  const mat = (name) => mv.model && mv.model.getMaterialByName(name);
  const canvasToUrl = (c) => new Promise((res) => c.toBlob((b) => res(URL.createObjectURL(b)), 'image/png'));
  async function isPng(file) {
    const head = new Uint8Array(await file.slice(0, 8).arrayBuffer());
    return [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a].every((b, i) => head[i] === b);
  }
  async function hasTransparency(file) {
    const bmp = await createImageBitmap(file);
    const c = document.createElement('canvas'); c.width = c.height = 64;
    const ctx = c.getContext('2d'); ctx.drawImage(bmp, 0, 0, 64, 64);
    const d = ctx.getImageData(0, 0, 64, 64).data;
    for (let i = 3; i < d.length; i += 4) if (d[i] < 250) return true;
    return false;
  }

  async function fitImage(source, zone) {
    const z = ZONES[zone], f = state.fit[zone];
    const bmp = source instanceof Blob ? await createImageBitmap(source) : source;
    const c = document.createElement('canvas'); c.width = z.w; c.height = z.h;
    const ctx = c.getContext('2d');
    let bx = 0, by = 0, bw = z.w, bh = z.h;
    if (zone === 'Cabezal') {           // default box: centred, 260 px tall; the size slider scales it around the centre
      const k = f.zoom / 100;
      bw = 1100 * k; bh = 260 * k; bx = (z.w - bw) / 2; by = (z.h - bh) / 2;
    }
    let s = z.fit === 'cover' ? Math.max(bw / bmp.width, bh / bmp.height) : Math.min(bw / bmp.width, bh / bmp.height);
    let ox = 0, oy = 0;
    if (zone !== 'Cabezal') { s *= f.zoom / 100; ox = (f.x / 100) * bw; oy = (f.y / 100) * bh; }
    const dw = bmp.width * s, dh = bmp.height * s;
    if (zone === 'MonedaImg') { ctx.beginPath(); ctx.arc(z.w / 2, z.h / 2, z.w / 2, 0, Math.PI * 2); ctx.clip(); }
    ctx.drawImage(bmp, bx + (bw - dw) / 2 + ox, by + (bh - dh) / 2 + oy, dw, dh);
    if (source instanceof Blob && bmp.close) bmp.close();
    return canvasToUrl(c);
  }

  const originalTex = {};
  async function setZoneTexture(zone, url) {
    const m = mat(zone);
    if (!m) return;
    m.pbrMetallicRoughness.baseColorTexture.setTexture(await mv.createTexture(url));
    m.pbrMetallicRoughness.setBaseColorFactor([1, 1, 1, 1]);
  }
  function restoreZone(zone) {
    const m = mat(zone);
    if (!m) return;
    m.pbrMetallicRoughness.baseColorTexture.setTexture(originalTex[zone] || null);
    m.pbrMetallicRoughness.setBaseColorFactor([1, 1, 1, 1]);
  }
  function setZoneVisible(zone, on) {
    const m = mat(zone);
    if (m) m.pbrMetallicRoughness.setBaseColorFactor([1, 1, 1, on ? 1 : 0]);
  }
  async function cabezalPlaceholder() {          // example text until the customer uploads their own name/logo
    const z = ZONES.Cabezal;
    const c = document.createElement('canvas'); c.width = z.w; c.height = z.h;
    const ctx = c.getContext('2d');
    ctx.font = 'italic 900 190px "Arial Black", "Helvetica Neue", Arial, sans-serif';
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.lineJoin = 'round';
    ctx.lineWidth = 26; ctx.strokeStyle = '#1b1430'; ctx.strokeText(T.placeholder, z.w / 2, z.h / 2 + 8);
    ctx.fillStyle = '#ffffff'; ctx.fillText(T.placeholder, z.w / 2, z.h / 2 + 8);
    await setZoneTexture('Cabezal', await canvasToUrl(c));
    const m = mat('Cabezal');
    if (m) originalTex.Cabezal = m.pbrMetallicRoughness.baseColorTexture.texture;
  }
  async function refreshZone(zone) {
    if (!state.ready || !ZONES[zone]) return;
    const file = state.uploads[zone];
    if (!file) { restoreZone(zone); return; }
    await setZoneTexture(zone, await fitImage(file, zone));
  }

  /* ---------- camera ---------- */
  const views = $$('.pkrm-bl__view');
  const ORBIT = { front: '0deg 88deg 0.5m', back: '180deg 88deg 0.5m', side: '62deg 84deg 0.5m', coin: '0deg 88deg 0.075m' };
  function setSpin(on) {
    if (on) mv.setAttribute('auto-rotate', ''); else mv.removeAttribute('auto-rotate');
    views.forEach((b) => { if (b.dataset.view === 'spin') { b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); } });
  }
  function look(side, spin = false) {
    if (mv.resetTurntableRotation) mv.resetTurntableRotation(0);
    mv.cameraTarget = side === 'coin' ? '0.0005m 0.083m 0.01m' : 'auto auto auto';
    mv.fieldOfView = 'auto';
    mv.cameraOrbit = ORBIT[side] || ORBIT.front;
    views.forEach((b) => b.dataset.view !== 'spin' && b.dataset.view !== 'home' && b.classList.toggle('is-on', b.dataset.view === side));
    setSpin(spin);
  }
  const HOME_ORBIT = mv.getAttribute('camera-orbit') || '25deg 82deg 0.5m';
  function home() {
    if (mv.resetTurntableRotation) mv.resetTurntableRotation(0);
    mv.cameraTarget = 'auto auto auto'; mv.fieldOfView = 'auto'; mv.cameraOrbit = HOME_ORBIT;
    views.forEach((b) => b.dataset.view !== 'spin' && b.classList.remove('is-on'));
    setSpin(false);
  }
  views.forEach((b) => b.addEventListener('click', () => {
    if (b.dataset.view === 'spin') setSpin(!mv.hasAttribute('auto-rotate'));
    else if (b.dataset.view === 'home') home();
    else look(b.dataset.view);
  }));
  $$('[data-zone-focus]').forEach((fs) => fs.addEventListener('focusin', () => look(fs.dataset.zoneFocus)));

  /* ---------- colours (one palette, four parts) ---------- */
  const swWrap = $('[data-swatches]');
  const partBtns = $$('[data-part]');
  const PART_VIEW = { Cuerpo: 'front', AlmSup: 'side', AlmInf: 'side', Moneda: 'coin' };
  function renderSwatches() {
    swWrap.innerHTML = '';
    const cur = state.colors[state.part];
    (cfg.colors[state.line] || []).forEach((c) => {
      const b = document.createElement('button');
      b.type = 'button';
      const on = cur && cur.name === c.name && cur.line === state.line;
      b.className = 'pkrm-bl__sw' + (on ? ' is-on' : '');
      b.style.setProperty('--sw', c.hex);
      b.title = cname(c);
      b.setAttribute('role', 'radio'); b.setAttribute('aria-label', cname(c)); b.setAttribute('aria-checked', on);
      b.addEventListener('click', () => setColor(state.part, { ...c, line: state.line }));
      swWrap.appendChild(b);
    });
  }
  function renderParts() {
    partBtns.forEach((b) => {
      const c = state.colors[b.dataset.part];
      const on = b.dataset.part === state.part;
      b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on);
      if (c) { $('.pkrm-bc__dot', b).style.setProperty('--c', c.hex); $('[data-part-name]', b).textContent = `${cname(c)} · ${c.line === 'PLA Matte' ? T.matte_s : T.gloss_s}`; }
    });
  }
  function applyColor(part) {
    const m = mat(part), c = state.colors[part];
    if (!m || !c) return;
    m.pbrMetallicRoughness.setBaseColorFactor(c.hex);
    m.pbrMetallicRoughness.setRoughnessFactor(c.line === 'PLA Matte' ? 0.9 : 0.42);
  }
  function setColor(part, c) {
    state.colors[part] = c;
    $(`[data-color-input="${part}"]`).value = `${c.name} · Bambu ${c.line} · ${c.code}`;
    applyColor(part); renderParts(); renderSwatches();
  }
  function selectLine(line) {
    state.line = line;
    $$('.pkrm-bl__tab').forEach((x) => { const on = x.dataset.line === line; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
    renderSwatches();
  }
  partBtns.forEach((b) => b.addEventListener('click', () => {
    state.part = b.dataset.part;
    const c = state.colors[state.part];
    if (c) selectLine(c.line);
    renderParts(); renderSwatches();
    look(PART_VIEW[state.part]);
  }));
  $$('.pkrm-bl__tab').forEach((t) => t.addEventListener('click', () => selectLine(t.dataset.line)));

  /* ---------- uploads + adjust ---------- */
  const fitInputs = {};
  $$('[data-adjust]').forEach((box) => {
    const zone = box.dataset.adjust;
    const input = $(`[data-fit-input="${zone}"]`);
    fitInputs[zone] = input;
    const ctl = { zoom: $('[data-fit="zoom"]', box), x: $('[data-fit="x"]', box), y: $('[data-fit="y"]', box) };
    let timer;
    const sync = () => {
      const f = { zoom: +ctl.zoom.value, x: ctl.x ? +ctl.x.value : 0, y: ctl.y ? +ctl.y.value : 0 };
      state.fit[zone] = f;
      $('[data-out="zoom"]', box).textContent = `${f.zoom}%`;
      const sign = (n) => (n > 0 ? '+' : '') + n;
      input.value = ctl.x ? `Tamaño ${f.zoom}% · horizontal ${sign(f.x)}% · vertical ${sign(f.y)}%` : `${f.zoom}%`;
      clearTimeout(timer); timer = setTimeout(() => refreshZone(zone), 50);
    };
    box._reset = () => { ctl.zoom.value = 100; if (ctl.x) ctl.x.value = 0; if (ctl.y) ctl.y.value = 0; sync(); };
    Object.values(ctl).forEach((r) => r && r.addEventListener('input', () => { look(ZONES[zone].side); sync(); }));
    $('[data-fit-reset]', box).addEventListener('click', () => { look(ZONES[zone].side); box._reset(); });
  });

  $$('[data-upload]').forEach((box) => {
    const zone = box.dataset.upload;
    const input = $('[data-file]', box), label = $('[data-label]', box), clear = $('[data-clear]', box), drop = $('.pkrm-bl__drop', box);
    const emptyLabel = label.textContent;
    const adjust = $(`[data-adjust="${zone}"]`);
    const reset = () => {
      input.value = ''; delete state.uploads[zone];
      label.textContent = emptyLabel; drop.classList.remove('has-file'); drop.style.removeProperty('--thumb'); clear.hidden = true;
      if (adjust) { adjust.hidden = true; adjust._reset(); }
    };
    input.addEventListener('change', async () => {
      showError('');
      const file = input.files[0];
      if (!file) { reset(); refreshZone(zone); return; }
      if (!(await isPng(file))) { reset(); showError(T.e_png); return; }
      if (file.size > cfg.maxBytes) { reset(); showError(T.e_big); return; }
      state.uploads[zone] = file;
      label.textContent = file.name.length > 26 ? file.name.slice(0, 23) + '…' : file.name;
      drop.classList.add('has-file'); drop.style.setProperty('--thumb', `url("${URL.createObjectURL(file)}")`);
      clear.hidden = false;
      if (!ZONES[zone]) return;                    // extra coins: stored only
      look(ZONES[zone].side);
      if (adjust) { adjust.hidden = false; adjust._reset(); }
      await refreshZone(zone);
      const { w, h } = await createImageBitmap(file).then((b) => ({ w: b.width, h: b.height }));
      if (Math.max(w, h) < ZONES[zone].min) showError(fmt(T.e_low, { w, h, ideal: ZONES[zone].ideal }));
      else if (zone !== 'Trasera' && !(await hasTransparency(file))) showError(T.e_bg);
    });
    clear.addEventListener('click', () => { reset(); refreshZone(zone); });
  });

  /* ---------- extra coins (variants) ---------- */
  const coinsWrap = $('[data-coins]');
  const variantInput = $('input[name="id"]', form);
  const priceEl = $('[data-pkrm-price]');
  const buy = $('[data-buy]');
  let buyLabel = buy.textContent.trim();
  const money = (n) => new Intl.NumberFormat(EN ? 'en-IE' : 'es-ES', { style: 'currency', currency: 'EUR' }).format(n / 100);
  const variants = cfg.variants || [];
  const base = variants[0] ? variants[0].price : 0;
  let extras = 0;
  function selectCoins(n) {
    const v = variants[n];
    if (!v) return;
    extras = n;
    $$('button', coinsWrap).forEach((b, i) => { b.classList.toggle('is-on', i === n); b.setAttribute('aria-checked', i === n); });
    variantInput.value = v.id;
    priceEl.textContent = money(v.price);
    buyLabel = v.available ? `${T.add} · ${money(v.price)}` : T.sold_out;
    buy.disabled = !v.available; buy.textContent = buyLabel;
    $$('[data-extra-slot]').forEach((s) => { s.hidden = +s.dataset.extraSlot > n; });
  }
  variants.forEach((v, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'pkrm-bc__coin'; b.setAttribute('role', 'radio');
    b.innerHTML = `${i === 0 ? T.none : '+' + i}<small>${i === 0 ? T.included : '+' + money(v.price - base)}</small>`;
    b.disabled = !v.available;
    b.addEventListener('click', () => selectCoins(i));
    coinsWrap.appendChild(b);
  });

  /* ---------- photos + zoom dialog ---------- */
  const zoomDlg = $('[data-zoom-dialog]');
  const openZoom = (src, alt) => { if (!zoomDlg || !zoomDlg.showModal) return; const big = $('img', zoomDlg); big.src = src; big.alt = alt || ''; zoomDlg.showModal(); };
  $$('[data-photo]').forEach((b) => b.addEventListener('click', () => openZoom(b.dataset.photo, $('img', b) && $('img', b).alt)));
  if (zoomDlg) {
    $('[data-zoom-close]', zoomDlg).addEventListener('click', () => zoomDlg.close());
    zoomDlg.addEventListener('click', (e) => { if (e.target === zoomDlg) zoomDlg.close(); });
  }

  /* ---------- order preview + submit ---------- */
  async function snapshot(side) {
    if (mv.resetTurntableRotation) mv.resetTurntableRotation(0);
    mv.cameraTarget = 'auto auto auto'; mv.fieldOfView = 'auto';
    mv.cameraOrbit = ORBIT[side];
    mv.jumpCameraToGoal();
    await nextFrame(); await nextFrame();
    return createImageBitmap(await mv.toBlob({ mimeType: 'image/png', idealAspect: true }));
  }
  async function buildPreview() {
    const wasSpinning = mv.hasAttribute('auto-rotate');
    setSpin(false);
    const empty = Object.keys(ZONES).filter((z) => !state.uploads[z]);
    empty.forEach((z) => setZoneVisible(z, false));      // the preview shows only what will be printed
    const front = await snapshot('front');
    const back = await snapshot('back');
    empty.forEach((z) => setZoneVisible(z, true));
    look('front', wasSpinning);
    const c = document.createElement('canvas');
    c.width = front.width + back.width; c.height = Math.max(front.height, back.height);
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, c.width, c.height);
    ctx.drawImage(front, 0, 0); ctx.drawImage(back, front.width, 0);
    return new Promise((res) => c.toBlob(res, 'image/png'));
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    showError('');
    const rights = $('[data-rights]');
    if (Object.keys(state.uploads).length && !rights.checked) { showError(T.e_rights); rights.focus(); return; }
    buy.disabled = true; buy.textContent = T.preparing;
    try {
      const pf = $('[data-preview-file]');
      try {
        const blob = await buildPreview();
        const dt = new DataTransfer();
        dt.items.add(new File([blob], 'vista-previa-booster-case.png', { type: 'image/png' }));
        pf.files = dt.files; pf.disabled = false;
      } catch (e2) { pf.disabled = true; }
      $$('[data-file]').forEach((i) => { i.disabled = !i.files || !i.files.length; });
      $$('[data-extra-slot]').forEach((s) => { if (+s.dataset.extraSlot > extras) $('[data-file]', s).disabled = true; });
      Object.entries(fitInputs).forEach(([z, i]) => { i.disabled = !state.uploads[z]; });
      HTMLFormElement.prototype.submit.call(form);
    } catch (e3) {
      buy.disabled = false; buy.textContent = buyLabel;
      showError(T.e_fail);
    }
  });
  window.addEventListener('pageshow', () => {
    $$('input, select', form).forEach((i) => { i.disabled = false; });
    selectCoins(extras);
  });

  /* ---------- init ---------- */
  const all = Object.entries(cfg.colors).flatMap(([line, arr]) => arr.map((c) => ({ ...c, line })));
  Object.keys(PARTS).forEach((p) => {
    const want = (cfg.defaults || {})[p];
    const c = all.find((x) => x.name === want && x.line === 'PLA Basic') || all.find((x) => x.name === want) || all[0];
    state.colors[p] = c;
    $(`[data-color-input="${p}"]`).value = `${c.name} · Bambu ${c.line} · ${c.code}`;
  });
  selectLine(state.colors.Cuerpo.line);
  renderParts();
  selectCoins(0);

  const onLoad = () => {
    if (!mat('Cuerpo')) return;
    state.ready = true;
    ['Trasera', 'MonedaImg'].forEach((z) => { const m = mat(z); if (m) originalTex[z] = m.pbrMetallicRoughness.baseColorTexture.texture; });
    if (!state.uploads.Cabezal) cabezalPlaceholder();
    Object.keys(PARTS).forEach(applyColor);
    Object.keys(state.uploads).forEach(refreshZone);
    root.classList.add('is-ready');
    window.__pkrmBC = { mv, state, ready: true };
  };
  mv.addEventListener('load', onLoad);
  if (mv.loaded) onLoad();
  mv.addEventListener('progress', (e) => { const p = $('[data-pkrm-progress]'); if (p) p.hidden = e.detail.totalProgress >= 1; });
  mv.addEventListener('pointerdown', () => setSpin(false), { passive: true });
})();
